export enum UserTypeEnum{
    Admin="Admin",
    Waiter="Waiter",
    CompanyManager="CompanyManager",
}